import React from "react";
import ExcelDownloader from "../../common/ExcelDownloader/ExcelDownloader";
import { getSimpleFormattedDate } from "../../../utils/utils";

const DATE_REGEX = /^\d{2}\/\d{2}\/\d{4}$/;

const isDateColumn = (id) => DATE_REGEX.test(id);

const generateSimpleHeaders = (columns) =>
  columns
    .filter(
      (col) =>
        col.id === "type" || col.id === "cashflow" || isDateColumn(col.id),
    )
    .map(({ id, label, type }) => ({
      key: id,
      label,
      type: type || "string",
    }));

const generateTableData = (headers, data) =>
  data.map((row) => {
    const filteredRow = {};
    headers.forEach(({ key }) => {
      filteredRow[key] = row[key];
    });
    return filteredRow;
  });

const NIISensitivityModelerExport = ({
  niiInputTablecolumn = [],
  niiInputTableData = [],
  niiOutputTablecolumn = [],
  niiOutputTableData = [],
  niiResultTableColumn = [],
  niiResultTableData = [],
  disabled = true,
}) => {
  // INPUT SHEET
  const inputHeaders = generateSimpleHeaders(niiInputTablecolumn);
  const inputData = generateTableData(inputHeaders, niiInputTableData);

  // OUTPUT SHEET
  const outputHeaders = generateSimpleHeaders(niiOutputTablecolumn);
  const outputData = generateTableData(outputHeaders, niiOutputTableData);

  return (
    <ExcelDownloader
      sheets={[
        {
          name: "Input_Table",
          header: inputHeaders,
          data: inputData,
          showHeader: true,
        },
        {
          name: "Output_Table",
          header: outputHeaders,
          data: outputData,
          showHeader: true,
        },
        {
          name: "Result_Table",
          title: niiResultTableColumn?.[0]?.label, // merged & centered
          header: [
            { key: "name", label: "Name" },
            { key: "value", label: "Value" },
          ],
          data: niiResultTableData,
          showHeader: false, // No column header row
        },
      ]}
      fileName={`NIISensitivityModeler_${getSimpleFormattedDate()}.xlsx`}
      disabled={disabled}
    />
  );
};

export default NIISensitivityModelerExport;
